import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation } from "swiper";
import React, { useRef } from "react";
import { FiArrowLeft, FiArrowRight } from "react-icons/fi";
import Button from "./Button";
import "swiper/css/navigation";

import "../assets/css/swiper.css";
import Text from "../components/Text";
import SingleSnackCard from "./SingleSnackCard";

const Snacks = (props) => {
  const data = props.data;
  const prevRef = useRef(null);
  const nextRef = useRef(null);

  return (
    <div className="flex justify-center">
      <div className="w-full">
        <div className="heading px-4">
          <Text component="h3" classes={"text-xl font-normal text-[#9b9b9b]"}>
            {props.children}
          </Text>
        </div>
        <div className="cards py-6 relative">
          <Swiper
            modules={[Autoplay, Navigation]}
            navigation
            onInit={(swiper) => {
              swiper.params.navigation.prevEl = prevRef.current;
              swiper.params.navigation.nextEl = nextRef.current;
              swiper.navigation.init();
              swiper.navigation.update();
            }}
            breakpoints={{
              1200: {
                slidesPerView: 4,
              },
              768: {
                slidesPerView: 3,
              },
              540: {
                slidesPerView: 2,
              },
              320: {
                slidesPerView: 1,
              },
            }}
            // autoplay={{
            //   delay: 3000,
            //   disableOnInteraction: false,
            // }}
            className=""
          >
            {data.snacks &&
              data.snacks.map((card, index) => {
                return (
                  <SwiperSlide key={index}>
                    <SingleSnackCard snackImage={card.src} />
                  </SwiperSlide>
                );
              })}

            <div
              ref={nextRef}
              className="next cursor-pointer text-2xl absolute z-10 top-1/2 right-0 -translate-y-1/2  p-2 rounded-full bg-gray-100 xs:hidden sm:flex"
            >
              <FiArrowRight />
            </div>
            <div
              ref={prevRef}
              className="prev cursor-pointer text-2xl absolute z-10 top-1/2 left-0 -translate-y-1/2  p-2 rounded-full bg-gray-100 xs:hidden sm:flex"
            >
              <FiArrowLeft />
            </div>
          </Swiper>
        </div>
        <div className="button flex justify-center">
          <Button transition isHovered>
            Explore Now
          </Button>
        </div>
      </div>
    </div>
  );
};

export default Snacks;
